const DashboardActionTypes = {
	DASHBOARD_START: 'dashboard_start',
	DASHBOARD_SUCCESS: 'dashboard_success',
	DASHBOARD_FAILURE: 'dashboard_failure',
	DASHBOARD_RESPONSE_CHANGED: 'dashboard_response_changed',
	DASHBOARD_RESPONSE_REST_START: 'dashboard_response_rest_start',
	GET_SECTION_LIST_FOR_DASHBOARD_START: 'get_section_list_for_dashboard_start',
	GET_SECTION_LIST_FOR_DASHBOARD_SUCCESS: 'get_section_list_for_dashboard_success',
	GET_SECTION_LIST_FOR_DASHBOARD_FAILURE: 'get_section_list_for_dashboard_failure',
	GET_SECTION_LIST_FOR_DASHBOARD_RESPONSE_CHANGED: 'get_section_list_for_dashboard_response_changed',
	GET_SECTION_LIST_FOR_DASHBOARD_RESPONSE_REST_START: 'get_section_list_for_dashboard_response_rest_start',
	GET_SECTION_LIST_FOR_DASHBOARD_RESPONSE_REST_SUCCESS: 'get_section_list_for_dashboard_response_rest_success',
	GET_PENDING_LEAVE_REQUESTS_START: 'get_pending_leave_requests_start',
	GET_PENDING_LEAVE_REQUESTS_SUCCESS: 'get_pending_leave_requests_success',
	GET_PENDING_LEAVE_REQUESTS_FAILURE: 'get_pending_leave_requests_failure',
	GET_PENDING_LEAVE_REQUESTS_RESPONSE_CHANGED: 'get_pending_leave_requests_response_changed',
	GET_PENDING_LEAVE_REQUESTS_RESPONSE_REST_START: 'get_pending_leave_requests_response_rest_start',
	// Enhanced Employee List Actions
	EMPLOYEE_LIST_ENHANCED_START: 'employee_list_enhanced_start',
	EMPLOYEE_LIST_ENHANCED_SUCCESS: 'employee_list_enhanced_success',
	EMPLOYEE_LIST_ENHANCED_FAILURE: 'employee_list_enhanced_failure',
	EMPLOYEE_LIST_ENHANCED_RESPONSE_CHANGED: 'employee_list_enhanced_response_changed',
	EMPLOYEE_LIST_ENHANCED_RESPONSE_REST_START: 'employee_list_enhanced_response_rest_start',
	// Checked In Card Employee List Actions
	GET_CHECKED_IN_CARD_EMPLOYEE_LIST_START: 'get_checked_in_card_employee_list_start',
	GET_CHECKED_IN_CARD_EMPLOYEE_LIST_SUCCESS: 'get_checked_in_card_employee_list_success',
	GET_CHECKED_IN_CARD_EMPLOYEE_LIST_FAILURE: 'get_checked_in_card_employee_list_failure',
	GET_CHECKED_IN_CARD_EMPLOYEE_LIST_RESPONSE_CHANGED: 'get_checked_in_card_employee_list_response_changed',
	GET_CHECKED_IN_CARD_EMPLOYEE_LIST_RESPONSE_REST_START: 'get_checked_in_card_employee_list_response_rest_start',
	// Active Employees Card Employee List Actions
	GET_ACTIVE_EMPLOYEES_CARD_EMPLOYEE_LIST_START: 'get_active_employees_card_employee_list_start',
	GET_ACTIVE_EMPLOYEES_CARD_EMPLOYEE_LIST_SUCCESS: 'get_active_employees_card_employee_list_success',
	GET_ACTIVE_EMPLOYEES_CARD_EMPLOYEE_LIST_FAILURE: 'get_active_employees_card_employee_list_failure',
	GET_ACTIVE_EMPLOYEES_CARD_EMPLOYEE_LIST_RESPONSE_CHANGED: 'get_active_employees_card_employee_list_response_changed',
	GET_ACTIVE_EMPLOYEES_CARD_EMPLOYEE_LIST_RESPONSE_REST_START: 'get_active_employees_card_employee_list_response_rest_start',
	// Late Check In Card Employee List Actions
	GET_LATE_CHECK_IN_CARD_EMPLOYEE_LIST_START: 'get_late_check_in_card_employee_list_start',
	GET_LATE_CHECK_IN_CARD_EMPLOYEE_LIST_SUCCESS: 'get_late_check_in_card_employee_list_success',
	GET_LATE_CHECK_IN_CARD_EMPLOYEE_LIST_FAILURE: 'get_late_check_in_card_employee_list_failure',
	GET_LATE_CHECK_IN_CARD_EMPLOYEE_LIST_RESPONSE_CHANGED: 'get_late_check_in_card_employee_list_response_changed',
	GET_LATE_CHECK_IN_CARD_EMPLOYEE_LIST_RESPONSE_REST_START: 'get_late_check_in_card_employee_list_response_rest_start',
	// Early Check Out Card Employee List Actions
	GET_EARLY_CHECK_OUT_CARD_EMPLOYEE_LIST_START: 'get_early_check_out_card_employee_list_start',
	GET_EARLY_CHECK_OUT_CARD_EMPLOYEE_LIST_SUCCESS: 'get_early_check_out_card_employee_list_success',
	GET_EARLY_CHECK_OUT_CARD_EMPLOYEE_LIST_FAILURE: 'get_early_check_out_card_employee_list_failure',
	GET_EARLY_CHECK_OUT_CARD_EMPLOYEE_LIST_RESPONSE_CHANGED: 'get_early_check_out_card_employee_list_response_changed',
	GET_EARLY_CHECK_OUT_CARD_EMPLOYEE_LIST_RESPONSE_REST_START: 'get_early_check_out_card_employee_list_response_rest_start',
	// On Leave Card Employee List Actions
	GET_ON_LEAVE_CARD_EMPLOYEE_LIST_START: 'get_on_leave_card_employee_list_start',
	GET_ON_LEAVE_CARD_EMPLOYEE_LIST_SUCCESS: 'get_on_leave_card_employee_list_success',
	GET_ON_LEAVE_CARD_EMPLOYEE_LIST_FAILURE: 'get_on_leave_card_employee_list_failure',
	GET_ON_LEAVE_CARD_EMPLOYEE_LIST_RESPONSE_CHANGED: 'get_on_leave_card_employee_list_response_changed',
	GET_ON_LEAVE_CARD_EMPLOYEE_LIST_RESPONSE_REST_START: 'get_on_leave_card_employee_list_response_rest_start',
	// Absent Card Employee List Actions
	GET_ABSENT_CARD_EMPLOYEE_LIST_START: 'get_absent_card_employee_list_start',
	GET_ABSENT_CARD_EMPLOYEE_LIST_SUCCESS: 'get_absent_card_employee_list_success',
	GET_ABSENT_CARD_EMPLOYEE_LIST_FAILURE: 'get_absent_card_employee_list_failure',
	GET_ABSENT_CARD_EMPLOYEE_LIST_RESPONSE_CHANGED: 'get_absent_card_employee_list_response_changed',
	GET_ABSENT_CARD_EMPLOYEE_LIST_RESPONSE_REST_START: 'get_absent_card_employee_list_response_rest_start',
	// Dashboard Card Actions
	GET_ACTIVE_EMPLOYEES_CARD_START: 'get_active_employees_card_start',
	GET_ACTIVE_EMPLOYEES_CARD_SUCCESS: 'get_active_employees_card_success',
	GET_ACTIVE_EMPLOYEES_CARD_FAILURE: 'get_active_employees_card_failure',
	GET_CHECKED_IN_CARD_START: 'get_checked_in_card_start',
	GET_CHECKED_IN_CARD_SUCCESS: 'get_checked_in_card_success',
	GET_CHECKED_IN_CARD_FAILURE: 'get_checked_in_card_failure',
	GET_LATE_CHECK_IN_CARD_START: 'get_late_check_in_card_start',
	GET_LATE_CHECK_IN_CARD_SUCCESS: 'get_late_check_in_card_success',
	GET_LATE_CHECK_IN_CARD_FAILURE: 'get_late_check_in_card_failure',
	GET_EARLY_CHECK_OUT_CARD_START: 'get_early_check_out_card_start',
	GET_EARLY_CHECK_OUT_CARD_SUCCESS: 'get_early_check_out_card_success',
	GET_EARLY_CHECK_OUT_CARD_FAILURE: 'get_early_check_out_card_failure',
	GET_ON_LEAVE_CARD_START: 'get_on_leave_card_start',
	GET_ON_LEAVE_CARD_SUCCESS: 'get_on_leave_card_success',
	GET_ON_LEAVE_CARD_FAILURE: 'get_on_leave_card_failure',
	GET_ABSENT_CARD_START: 'get_absent_card_start',
	GET_ABSENT_CARD_SUCCESS: 'get_absent_card_success',
	GET_ABSENT_CARD_FAILURE: 'get_absent_card_failure',
	// Card Keys for encryption
	GET_ACTIVE_EMPLOYEES_CARD_KEY: 'GetActiveEmployeesCardFromWeb',
	GET_CHECKED_IN_CARD_KEY: 'GetCheckedInCardFromWeb',
	GET_LATE_CHECK_IN_CARD_KEY: 'GetLateCheckInCardFromWeb',
	GET_EARLY_CHECK_OUT_CARD_KEY: 'GetEarlyCheckOutCardFromWeb',
	GET_ON_LEAVE_CARD_KEY: 'GetOnLeaveCardFromWeb',
	GET_ABSENT_CARD_KEY: 'GetAbsentCardFromWeb',
};



export default DashboardActionTypes;
